'use client';

/**
 * Noua iconiță SoftFactura (2026). SVG inline cu forma completă.
 * Culoarea vine din `color` (CSS), setată prin `text-primary`.
 */
interface BrandLogoIconProps {
  className?: string;
  size?: number;
}

export function BrandLogoIcon({ className = 'text-primary', size = 32 }: BrandLogoIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 76.33 67.05"
      width={size}
      height={size}
      className={className}
      aria-label="SoftFactura"
      role="img"
    >
      <path
        d="M63.6,20.85L75.74,0H24.64C11.05,0,0,11.05,0,24.64c0,6.98,2.82,12.97,7.48,17.34l5.39-9.42c-1.54-2.26-2.43-4.99-2.43-7.92,0-7.83,6.37-14.2,14.2-14.2h32.94l-4.29,7.38c-.53-.03-1.07-.05-1.6-.05h-22.43L.59,67.05h12.39l11.96-20.89h23.94l5.48-9.42h-24.08l3.99-6.86h24.08c4.48,2.39,7.54,7.1,7.54,12.53,0,7.83-6.37,14.2-14.2,14.2h-25.1l-5.98,10.44h31.08c13.58,0,24.64-11.06,24.64-24.64,0-9.27-5.15-17.35-12.73-21.56Z"
        fill="currentColor"
      />
    </svg>
  );
}
